import { render, staticRenderFns } from "./username.vue?vue&type=template&id=5cf4c964&scoped=true&"
import script from "./username.vue?vue&type=script&lang=js&"
export * from "./username.vue?vue&type=script&lang=js&"
import style0 from "./username.vue?vue&type=style&index=0&id=5cf4c964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf4c964",
  null
  
)

export default component.exports